import lostPropertyForm from '../data/lost-property-new';
import plannedEventForm from '../data/planned-event-new';

export const environment = {
  production: true,
  namespace: (window as any).EIM.namespace,
  externalServiceUrl: (window as any).EIM.external,
  assetPath: `${(window as any).location.origin}/x/assets/${(window as any).EIM.ver}/assets/`,
  assetPathWithoutOrigin: `/x/assets/${(window as any).EIM.ver}/assets/`,
  forms: [
    lostPropertyForm,
    plannedEventForm
  ],
  reCaptchaSiteKey: '6Lc1WusUAAAAAGMrTMnZR5uK1P-gAVZo_zpnGP2h',
  appBaseHref: window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')
};
